<template>
	<div :class="{ disabled }">
		<FeatureTypeSelectorTabs class="mb-6 mt-2" v-model="selectedTabIndex" :featureTypesBySections="featureTypesBySections" />
		<div class="display-flex flex-wrap feature-types-boxes">
			<div
				:key="featureType.type"
				v-for="(featureType, i) in selectedTabFeatureTypesItems"
				:class="{ 'mr-6': i !== selectedTabFeatureTypesItems.length - 1 }"
			>
				<SIcon width="80" height="80" class="closed-beta-sign" name="creation-wizard-closed-beta" :class="{ show: featureType.disabled }" />
				<FeatureTypeBox
					role="button"
					class="box-container"
					:featureType="featureType"
					@click="onClickFeatureType(featureType)"
					:class="{ disabled: featureType.disabled }"
					:itemsBackgroundColor="selectedSection.itemsBackgroundColor"
					:bottomSectionBackgroundColor="selectedSection.bottomSectionBackgroundColor"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import FeatureTypeBox from '@/components/CreationWizard/Steps/ChooseProjectAndFeatureType/FeatureTypeSelector/FeatureTypeBox.vue';
import FeatureTypeSelectorTabs from '@/components/CreationWizard/Steps/ChooseProjectAndFeatureType/FeatureTypeSelector/FeatureTypeSelectorTabs.vue';
export default {
	name: 'FeatureTypeSelector',
	mixins: [VModelMixin],
	components: { FeatureTypeBox, FeatureTypeSelectorTabs },
	props: { disabled: { type: Boolean }, featureTypesBySections: { type: Array } },
	computed: {
		selectedTabFeatureTypesItems() {
			return this.selectedSection.items;
		},
		selectedSection() {
			return this.featureTypesBySections[this.selectedTabIndex];
		},
	},
	methods: {
		onClickFeatureType(featureType) {
			this.localValue = featureType.type;
			this.$emit('click', featureType.type);
		},
	},
	data() {
		return {
			selectedTabIndex: 0,
		};
	},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
$disabled-opacity: 0.36;
.feature-types-boxes {
	gap: 0px;
	&.disabled {
		pointer-events: none;
		opacity: $disabled-opacity;
	}
}
.closed-beta-sign {
	top: 0px;
	opacity: 0;
	z-index: 3;
	width: 80px;
	height: 80px;
	position: static;
	margin-bottom: -102px;
	&.show {
		opacity: 1;
	}
}
.box-container {
	z-index: 2;
}
.disabled {
	pointer-events: none;
	opacity: $disabled-opacity;
}
</style>
